/**
 * 车辆诊断表格数据(在此组件区分展示黄河设备和昆仑山设备)
 */
import React, { useEffect, useMemo } from 'react';
import { Tabs } from 'antd';
import CarOperationTable from './carOperationTable';
import KlsDeviceTable from './klsDeviceTable';
import KlsVersionTable from './klsVersionTable';
import KlsParamsTable from './klsParamsTable';
import KlsVehicleTypeTable from './klsVehicleTypeTable';
import KlsModemErrorTable from './klsModemErrorTable';
import JtDeviceErrorTable from './jtDeviceErrorTable';
import styles from './index.module.scss';
import CarOperationTableCxLx from './carOperationTableCxLx';
import { log } from 'console';
import KlsDeviceTableCxLx from './klsDeviceTableCxLx';
import KlsParamsTableCxLx from './klsParamsTableCxLx';
import KlsVersionTableCxLx from './klsVersionTableCxLx';
import { DeviceTypeEnum, getLxCxSubDeviceTypesByDeviceType, SubDeviceTypeEnum } from '@/constants/deviceManage';
import { isLingXing } from '@/utils/device';
import CalibrateTableDuolaimu from './calibrateTable/duolaimu';
import CalibrateTableYuanzhiyunCamera from './calibrateTable/yuanzhiyun-camera';
import CalibrateTableYuanzhiyunRadar from './calibrateTable/yuanzhiyun-rader';
import CalibrateTableWireMotor from './calibrateTable/wire-motor';
import CalibrateTableAqiIns from './calibrateTable/aqi-ins';
import CalibrateTableBsdLaserRadar from './calibrateTable/bsd-laser-radar';
import CalibrateTableAxForwardCamera from './calibrateTable/ax-forward-camera';
import CalibrateTableAxForwardMmwRadar from './calibrateTable/ax-forward-mmw-radar';
import CalibrateTableAxDmsCamera from './calibrateTable/ax-dms-camera';
import CalibrateTableAxBsdCamera from './calibrateTable/ax-bsd-camera';

interface CarDiagnosisTableProps {
  isKls: boolean; // 是否是昆仑山设备
  isKlsV3: boolean; // 是否是昆仑山3.0设备
  diagnosisSearchParams: any; // 搜索参数
  hasModem: boolean; // 是否安装行车记录仪
  hasJtDevice: boolean; // 是否安装部标机
  isChangxingLingxing?: boolean; // 是否是畅行领行设备
  deviceType?: DeviceTypeEnum; // 设备类型
  carId?: number; // 车辆ID
}

const CarDiagnosisTable = (props: CarDiagnosisTableProps) => {
  const { isKls, isKlsV3,
    diagnosisSearchParams,
    hasModem,
    isChangxingLingxing = false,
    deviceType,
    carId
  } = props;


  // 获取导出的参数
  const getExportParams = async () => {
    if (diagnosisSearchParams) {
      return {
        ...diagnosisSearchParams,
        export: true
      };
    }
  };

  // 获取子设备类型
  const subDeviceTypes = useMemo(() => {
    return getLxCxSubDeviceTypesByDeviceType(deviceType);
  }, [deviceType])

  const hasForwardRadar = useMemo(() => {
    return subDeviceTypes.includes(SubDeviceTypeEnum.forwardIntegratedMachine_radar_yuanzhiyun) ||
      subDeviceTypes.includes(SubDeviceTypeEnum.ax_forward_mmw_radar);
  }, [subDeviceTypes])

  if (isKls) {
    return (
      <div className={styles.carDiagnosisTable}>
        {/* <div className={styles.aebTitle}>AEB运行数据</div> */}
        <Tabs>
          <Tabs.TabPane tab="AEB车辆运行数据" key="operation">
            {
              isChangxingLingxing ? (
                <CarOperationTableCxLx
                  diagnosisSearchParams={diagnosisSearchParams}
                  getExportParams={getExportParams}
                  isKls
                  noTitle={true}
                  deviceType={deviceType}
                  hasForwardRadar={hasForwardRadar}
                />
              )
                : (<CarOperationTable
                  diagnosisSearchParams={diagnosisSearchParams}
                  getExportParams={getExportParams}
                  isKls
                  noTitle={true}
                />)
            }

          </Tabs.TabPane>
          <Tabs.TabPane tab="AEB设备状态变更" key="device">
            {
              isChangxingLingxing ? <KlsDeviceTableCxLx
                diagnosisSearchParams={diagnosisSearchParams}
                getExportParams={getExportParams}
                isKlsV3={isKlsV3}
                hasForwardRadar={hasForwardRadar}
                deviceType={deviceType}
              /> : <KlsDeviceTable
                diagnosisSearchParams={diagnosisSearchParams}
                getExportParams={getExportParams}
                isKlsV3={isKlsV3}
              />
            }
          </Tabs.TabPane>
          <Tabs.TabPane tab="AEB设备版本变更" key="version">
            {
              isChangxingLingxing ? <KlsVersionTableCxLx
                diagnosisSearchParams={diagnosisSearchParams}
                getExportParams={getExportParams}
              /> : <KlsVersionTable
                diagnosisSearchParams={diagnosisSearchParams}
                getExportParams={getExportParams}
              />
            }

          </Tabs.TabPane>
          <Tabs.TabPane tab="AEB设备参数变更" key="params">
            {
              isChangxingLingxing ? <KlsParamsTableCxLx
                diagnosisSearchParams={diagnosisSearchParams}
                getExportParams={getExportParams}
                isKlsV3={isKlsV3}
              /> : <KlsParamsTable
                diagnosisSearchParams={diagnosisSearchParams}
                getExportParams={getExportParams}
                isKlsV3={isKlsV3}
              />
            }

          </Tabs.TabPane>
          {
            isChangxingLingxing ? null : (
              <Tabs.TabPane tab="AEB车身类型变更" key="vehicleType">
                <KlsVehicleTypeTable
                  diagnosisSearchParams={diagnosisSearchParams}
                  getExportParams={getExportParams}
                />
              </Tabs.TabPane>
            )
          }
          {hasModem && (
            <Tabs.TabPane tab="AEB记录仪异常" key="modem">
              <KlsModemErrorTable
                diagnosisSearchParams={diagnosisSearchParams}
                getExportParams={getExportParams}
              />
            </Tabs.TabPane>
          )}
          {
            subDeviceTypes.includes(SubDeviceTypeEnum.forwardIntegratedMachine_duolaimu) && <Tabs.TabPane tab="标定结果-前向一体机" key="forward-duolaimu">
              <CalibrateTableDuolaimu diagnosisSearchParams={diagnosisSearchParams} carId={carId!} />
            </Tabs.TabPane>
          }
          {
            subDeviceTypes.includes(SubDeviceTypeEnum.forwardIntegratedMachine_camera_yuanzhiyun) && <Tabs.TabPane tab="标定结果-相机" key="forward-yuanzhiyun-camera">
              <CalibrateTableYuanzhiyunCamera diagnosisSearchParams={diagnosisSearchParams} carId={carId!} />
            </Tabs.TabPane>
          }
          {
            subDeviceTypes.includes(SubDeviceTypeEnum.forwardIntegratedMachine_radar_yuanzhiyun) && <Tabs.TabPane tab="标定结果-雷达" key="forward-yuanzhiyun-radar">
              <CalibrateTableYuanzhiyunRadar diagnosisSearchParams={diagnosisSearchParams} carId={carId!} />
            </Tabs.TabPane>
          }
          {
            subDeviceTypes.includes(SubDeviceTypeEnum.ins_aqi) && <Tabs.TabPane tab="标定结果-组合惯导" key="ins-aqi">
              <CalibrateTableAqiIns diagnosisSearchParams={diagnosisSearchParams} carId={carId} />
            </Tabs.TabPane>
          }
          {
            subDeviceTypes.includes(SubDeviceTypeEnum.wireMotor) && <Tabs.TabPane tab="标定结果-拉线电机" key="wire-motor">
              <CalibrateTableWireMotor diagnosisSearchParams={diagnosisSearchParams} carId={carId} />
            </Tabs.TabPane>
          }
          {
            subDeviceTypes.includes(SubDeviceTypeEnum.bsd_laser_radar) && <Tabs.TabPane tab="标定结果-BSD激光雷达" key="bsd-laser-radar">
              <CalibrateTableBsdLaserRadar diagnosisSearchParams={diagnosisSearchParams} carId={carId} />
            </Tabs.TabPane>
          }
          {
            subDeviceTypes.includes(SubDeviceTypeEnum.ax_forward_camera) && <Tabs.TabPane tab="标定结果-安行前向相机" key="ax-forward-camera">
              <CalibrateTableAxForwardCamera diagnosisSearchParams={diagnosisSearchParams} carId={carId!} />
            </Tabs.TabPane>
          }
          {
            subDeviceTypes.includes(SubDeviceTypeEnum.ax_forward_mmw_radar) && <Tabs.TabPane tab="标定结果-安行前向毫米波雷达" key="ax-forward-mmw-radar">
              <CalibrateTableAxForwardMmwRadar diagnosisSearchParams={diagnosisSearchParams} carId={carId!} />
            </Tabs.TabPane>
          }
          {
            subDeviceTypes.includes(SubDeviceTypeEnum.ax_dms_camera) && <Tabs.TabPane tab="标定结果-安行DMS相机" key="ax-dms-camera">
              <CalibrateTableAxDmsCamera diagnosisSearchParams={diagnosisSearchParams} carId={carId!} />
            </Tabs.TabPane>
          }
          {
            subDeviceTypes.includes(SubDeviceTypeEnum.ax_bsd_camera) && <Tabs.TabPane tab="标定结果-安行BSD相机" key="ax-bsd-camera">
              <CalibrateTableAxBsdCamera diagnosisSearchParams={diagnosisSearchParams} carId={carId!} />
            </Tabs.TabPane>
          }

        </Tabs>
      </div>
    );
  } else {
    return (
      <CarOperationTable
        diagnosisSearchParams={diagnosisSearchParams}
        getExportParams={getExportParams}
      />
    );
  }
};

export default React.memo(CarDiagnosisTable);
